import {useMutation} from 'react-query';
import {postFarmValidationFile} from './postFarmValidationFile';

interface IMutationPayload {
  loanGuid: string;
  formData: File;
}

const usePostFarmValidationFile = () => {
  const {mutateAsync, isLoading, isSuccess} = useMutation(
    ({loanGuid, formData}: IMutationPayload) =>
      postFarmValidationFile(loanGuid, formData),
  );

  return {
    mutateAsync,
    isLoading,
    isSuccess,
  };
};

export default usePostFarmValidationFile;
